import VisitorRoutes from './VisitorRoutes';

export * from './login';
export * from './types';

export default VisitorRoutes;
